var UI_VARIANT = /* @__PURE__ */ ((UI_VARIANT2) => {
  UI_VARIANT2["DEFAULT"] = "default";
  UI_VARIANT2["NEUTRAL"] = "neutral";
  UI_VARIANT2["WARNING"] = "warning";
  UI_VARIANT2["ERROR"] = "error";
  UI_VARIANT2["ALERT"] = "alert";
  UI_VARIANT2["SUCCESS"] = "success";
  return UI_VARIANT2;
})(UI_VARIANT || {});
var UI_SIZE = /* @__PURE__ */ ((UI_SIZE2) => {
  UI_SIZE2["LARGE"] = "large";
  UI_SIZE2["MEDIUM"] = "medium";
  UI_SIZE2["SMALL"] = "small";
  return UI_SIZE2;
})(UI_SIZE || {});
const WsStateBannerEnum = {
  Variant: UI_VARIANT,
  Size: UI_SIZE
};
export {
  UI_SIZE,
  UI_VARIANT,
  WsStateBannerEnum,
  WsStateBannerEnum as default
};
//# sourceMappingURL=WsStateBanner.enum.es.js.map
